export default {
    DECLARATOR_ONEOF: "oneOfProperty",
    GET_TEMPLATE_RECURSION_LIMIT: 1,
    floatingPointPrecision: 10000,
    propertyBlacklist: ["_id"]
};
